import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Skills")
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "quiz-basic-stage-skills__chips" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Continue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AppDropdown = _resolveComponent("AppDropdown")!
  const _component_AppChip = _resolveComponent("AppChip")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "What are your professional skills?",
    description: "Tell us about the special talents you bring that can help the team.",
    class: "quiz-basic-stage-skills",
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[4] || (_cache[4] = ($event: any) => (_ctx.QuizService.close())),
    prev: !_ctx.QuizService.editing.value
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, {
        onClick: _ctx.navigateNext,
        loading: _ctx.QuizService.isSaving()
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_AppDropdown, { type: "simple" }, {
        label: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AppSelect, {
            modelValue: _ctx.skills,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.skills) = $event)),
            multiple: "",
            options: _ctx.visibleSkills,
            "visible-options": _ctx.visibleSkills,
            min: 0,
            "clear-on-select": "",
            "clear-on-close": "",
            "close-on-select": true,
            "max-height": 200,
            searchable: "",
            placeholder: "Type to explore",
            "onSearch:focus": _cache[2] || (_cache[2] = () => (_ctx.hideSelectedSkill = false)),
            "onSearch:blur": _cache[3] || (_cache[3] = () => (_ctx.hideSelectedSkill = true)),
            "onSearch:input": _ctx.handleSkillSearch,
            onSelected: _ctx.saveSkill,
            class: _normalizeClass(_ctx.hideSelectedSkill ? 'hide-selected' : false)
          }, {
            toggle: _withCtx(({ isFocusing, toggle }) => [
              _createElementVNode("div", {
                onClick: toggle,
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent","stop"])),
                class: _normalizeClass(["app-dropdown__vue-select-trigger quiz-basic-stage-skills__dropdown-icon", { active: isFocusing }])
              }, [
                _createVNode(_component_AppIcon, {
                  name: "search-boxed",
                  size: "28"
                })
              ], 42, _hoisted_2)
            ]),
            "dropdown-item": _withCtx(({ option }) => [
              _createElementVNode("p", null, _toDisplayString(option), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "options", "visible-options", "onSearch:input", "onSelected", "class"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSkills, (skill, index) => {
          return (_openBlock(), _createBlock(_component_AppChip, {
            text: skill,
            divider: true,
            key: index,
            onOnRemove: ($event: any) => (_ctx.removeSkill(skill))
          }, null, 8, ["text", "onOnRemove"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["onQuizNavigation:back", "prev"]))
}